export const PERSONALIZATION_DEFAULTS = {
  preferredName: '', occupation: '', interests: '', goals: '',
  responseLength: 'default', tone: 'default', formatting: 'default', customInstructions: '', workCustomInstructions: '',
};
export const PERSONALIZATION_LIMITS = { preferredName: 80, occupation: 160, interests: 1000, goals: 1000, customInstructions: 3000, workCustomInstructions: 3000 };
export const PERSONALIZATION_OPTIONS = {
  responseLength: ['default', 'concise', 'detailed'],
  tone: ['default', 'casual', 'professional'],
  formatting: ['default', 'paragraphs', 'bullets'],
};
export function normalizePersonalization(value) {
  const result = { ...PERSONALIZATION_DEFAULTS };
  for (const key of Object.keys(result)) {
    if (typeof value?.[key] !== 'string') continue;
    if (PERSONALIZATION_OPTIONS[key]) {
      if (PERSONALIZATION_OPTIONS[key].includes(value[key])) result[key] = value[key];
    } else result[key] = value[key].slice(0, PERSONALIZATION_LIMITS[key]);
  }
  return result;
}
